import Loading from "@/components/global/Loading";
import { useCheckout } from "@/context/checkout";
import { ModalContext } from "@/pages/_app";
import { customStyles } from "@/styles/select.style";
// import { handleShippingAddress } from "@/utils/checkout/shippingAddress";
import { preventLettersInInput } from "@/utils/global";
import { AddressValidation } from "@/utils/valitation/checkout";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useContext } from "react";
import { useTranslation } from "next-i18next";
import ReactSelect from "react-select";
import { useSession } from "next-auth/react";
import { getCookie } from "cookies-next";
import { event_shipping_info } from "@/utils/gtm";

const AddEditAddress = ({ isPopup = false, editedAddress, cartData }) => {
  const { t } = useTranslation("checkout");
  const Context = useContext(ModalContext);
  const {
    checkout: { regions },
    dispatch,
  } = useCheckout();
  const { data: session } = useSession();
  const mage = getCookie("mage");

  const handleSubmit = async (values) => {
    event_shipping_info(cartData);
    const addressData = {
      ...values,
      ...(!!mage && !editedAddress ? { save_in_address_book: 1 } : {}),
    };
    // setSubmitting(true);
    // const res = await handleShippingAddress(addressData, dispatch);
    // setSubmitting(false);
    dispatch({ type: "shipping_address", payload: addressData });
    dispatch({ type: "isShipping_address_submiting", payload: true });
    // res &&
    isPopup && !editedAddress && Context?.dispatch({ type: "addNewAddress" });
    // res &&
    isPopup && editedAddress && Context?.dispatch({ type: "editAddress" });
  };

  const initialValues = {
    firstname: editedAddress?.firstname || session?.user?.firstname || "",
    lastname: editedAddress?.lastname || session?.user?.lastname || "",
    email: editedAddress?.email || session?.user?.email || "",
    city: editedAddress?.city?.trim() || "",
    region: editedAddress?.region?.trim() || "",
    region_id: editedAddress?.region_id || "",
    telephone:
      (editedAddress?.telephone
        ? "0"?.concat(editedAddress?.telephone?.slice(-9))
        : "") ||
      (session &&
        `0${session?.user?.custom_attributes?.[1]?.value?.slice(5)}`) ||
      "",
    street: editedAddress?.street
      ? typeof editedAddress?.street === "object"
        ? editedAddress?.street[0]
            .split("\n")
            .map((line) => line.trim())
            .filter((line) => line.length > 0)
            .join(",")
        : editedAddress?.street
            .split("\n")
            .map((line) => line.trim())
            .filter((line) => line.length > 0)
            .join(",")
      : "",
  };

  const currentRegion = regions?.find(
    (item) => item.value == editedAddress?.region_id
  );

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={AddressValidation(t)}
      enableReinitialize
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, setFieldValue }) => (
        <Form
          className={`grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-4 max-sm:text-sm ${
            isPopup ? "mt-3" : ""
          }`}
        >
          <div className="relative">
            <div>
              <label
                htmlFor="firstname"
                className="block w-full mb-1 text-zinc-500"
              >
                {t("First name")}
              </label>
              <Field
                id="firstname"
                name="firstname"
                placeholder={t("First name")}
                className="block w-full p-1.5 sm:p-2 border rounded-md outline-none border-slate-300 focus:border-primary-400"
              />
            </div>
            <ErrorMessage
              name="firstname"
              component="div"
              className="text-xs text-warning sm:text-sm"
            />
          </div>
          <div className="relative">
            <div>
              <label
                htmlFor="lastname"
                className="block w-full mb-1 text-zinc-500"
              >
                {t("Surname")}
              </label>
              <Field
                id="lastname"
                name="lastname"
                placeholder={t("Surname")}
                className="block w-full p-1.5 sm:p-2 border rounded-md outline-none border-slate-300 focus:border-primary-400"
              />
            </div>
            <ErrorMessage
              name="lastname"
              component="div"
              className="text-xs text-warning sm:text-sm"
            />
          </div>
          <div className="relative col-span-full">
            <div>
              <label
                htmlFor="email"
                className="block w-full mb-1 text-zinc-500"
              >
                {t("Email address")}
              </label>
              <Field
                id="email"
                name="email"
                placeholder="name@example.com"
                className="block w-full p-1.5 sm:p-2 border rounded-md outline-none border-slate-300 focus:border-primary-400"
              />
            </div>
            <ErrorMessage
              name="email"
              component="div"
              className="text-xs text-warning sm:text-sm"
            />
          </div>
          <div className="relative">
            <div>
              <label
                htmlFor="telephone"
                className="block w-full mb-1 text-zinc-500"
              >
                {t("Mobile number")}
              </label>
              <Field
                id="telephone"
                name="telephone"
                placeholder="05xxxxxxxx"
                onKeyDown={(event) => {
                  preventLettersInInput(event);
                }}
                maxLength="10"
                className="block w-full p-1.5 sm:p-2 border rounded-md outline-none text-left border-slate-300 focus:border-primary-400"
              />
            </div>
            <ErrorMessage
              name="telephone"
              component="div"
              className="text-xs text-warning sm:text-sm"
            />
          </div>
          <div className="relative">
            <div>
              <label htmlFor="city" className="block w-full mb-1 text-zinc-500">
                {t("Select city")}
              </label>
              <ReactSelect
                component={ReactSelect}
                name="city"
                id="city"
                placeholder={t("Please select a region, state or province")}
                onChange={(e) => {
                  setFieldValue("city", e.label);
                  setFieldValue("region", e.label);
                  setFieldValue("region_id", Number(e.value.value));
                  setFieldValue("country_id", e.country_id);
                }}
                options={regions
                  ?.map((r) => ({ value: r, label: r.label }))
                  .slice(1)}
                defaultValue={currentRegion}
                styles={customStyles}
              />
            </div>
            <ErrorMessage
              name="city"
              component="div"
              className="text-xs text-warning sm:text-sm"
            />
          </div>
          <div className="relative col-span-full">
            <div>
              <label
                htmlFor="street"
                className="block w-full mb-1 text-zinc-500"
              >
                {t("Street")}
              </label>
              <Field
                component="textarea"
                id="street"
                rows="5"
                name="street"
                placeholder={t("Address details")}
                className="block w-full p-1.5 sm:p-2 border rounded-md outline-none resize-none border-slate-300 focus:border-primary-400"
              />
            </div>
            <ErrorMessage
              name="street"
              component="div"
              className="text-xs text-warning sm:text-sm"
            />
          </div>
          <button
            disabled={isSubmitting}
            className="p-2 font-semibold text-white uppercase rounded-md col-span-full bg-primary"
          >
            {isSubmitting ? <Loading /> : t("Save Address")}
          </button>
        </Form>
      )}
    </Formik>
  );
};

export default AddEditAddress;
